module.exports = __webpack_public_path__ + "img/qrcode_for_wechat.62a5bc8d.jpg";